// extracted by mini-css-extract-plugin
export default {"search_logs_container":"SearchLogs_search_logs_container__ae8Ah","search_logs_fields":"SearchLogs_search_logs_fields__71k3A"};